export default {"src":"/_next/static/media/img-bfy-mobile-3.5cc9846d.svg","height":332,"width":328,"blurWidth":0,"blurHeight":0};